module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%",
      "padding": "40px 0"
    }
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('van-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cate_list.length > 1),
      expression: "cate_list.length>1"
    }],
    staticClass: "active-tab",
    attrs: {
      "animated": "",
      "sticky": ""
    },
    on: {
      "change": _vm.cateChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.cate_list), function(item, index) {
    return _c('van-tab', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _vm._l((_vm.list), function(item, i) {
    return _c('news-list-item', {
      key: i,
      attrs: {
        "NewsItemData": item
      },
      nativeOn: {
        "click": function($event) {
          return _vm.itemClickFun(item)
        }
      }
    })
  })], 2)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77b5ac83","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/news/NewsList.vue
// module id = 1544
// module chunks = 0